import React from 'react';
import { setItem } from '../../../utils/localStorage';
import { Modal } from '../../../app/common/sharedComponents/Modal';
import {
  ModalHeader,
  ModalContent,
} from '../../../app/common/sharedStyledComponents/Modal.styled';
import { Body4, Headline3 } from '../../../app/common/typography';
import { useTranslation } from 'react-i18next';
import { ButtonBlockColumn } from './../../../app/common/sharedStyledComponents/GenericStyles.styled';
import { ButtonLarge } from '../../../app/common/sharedComponents/buttons/ButtonLarge';
import { IUnsavedFormModal } from '../../../app/@types/modal';

const UnsavedFormDataModal = ({
  showUnsavedDataModal,
  setShowUnsavedDataModal,
  onContinue,
  onCancel,
}: IUnsavedFormModal) => {
  const { t } = useTranslation();
  return (
    <Modal
      isOpen={showUnsavedDataModal}
      handleModalClose={() => {
        if (onCancel) {
          onCancel();
        }
        setShowUnsavedDataModal(false);
      }}
    >
      <ModalHeader>
        <Headline3>
          {t('COMMON.OUTSIDE.MESSAGES.CONTINUE_WITHOUT_SAVING')}
        </Headline3>
      </ModalHeader>
      <ModalContent>
        <Body4>
          {t('COMMON.OUTSIDE.MESSAGES.CONTINUE_WITHOUT_SAVING_NOTE')}
        </Body4>
      </ModalContent>
      <ButtonBlockColumn>
        <ButtonLarge
          title={t('COMMON.OUTSIDE.BUTTONS.CONTINUE')}
          onClick={() => {
            if (onContinue) {
              onContinue();
            }
            setItem('isFormData', false);
            setShowUnsavedDataModal(false);
          }}
          backgroundColor="oxfordBlue"
        />
        <ButtonLarge
          title={t('COMMON.OUTSIDE.BUTTONS.CANCEL')}
          onClick={() => {
            if (onCancel) {
              onCancel();
            }
            setShowUnsavedDataModal(false);
          }}
          outlined={true}
          inverted={true}
        />
      </ButtonBlockColumn>
    </Modal>
  );
};

export default UnsavedFormDataModal;
